import { FC } from 'react';

import { Link } from '@inertiajs/react';
import { PackageCheck } from 'lucide-react';

import { Button } from '../../../components/ui/Button';
import { Routes } from '../../../models/routes';

export const FaqSupport: FC = () => (
    <section className="mt-16 rounded-3xl border bg-card p-6 text-center shadow-sm sm:p-10">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <PackageCheck className="h-6 w-6" />
        </div>
        <h2 className="mt-4 text-2xl font-bold">
            Не знайшли потрібної відповіді?
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-muted-foreground">
            Напишіть у підтримку й додайте номер замовлення, якщо питання
            стосується покупки або продажу. Так ми швидше розберемося в
            ситуації.
        </p>
        <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
            <Button asChild>
                <Link href="/contact">Написати в підтримку</Link>
            </Button>
            <Button variant="outline" asChild>
                <Link href={Routes.Terms}>Правила маркетплейсу</Link>
            </Button>
        </div>
    </section>
);
